import { Capacitor } from "@capacitor/core";

export const triggerHaptic = async (enabled, style = "Light") => {
	if (!enabled || !Capacitor.isNativePlatform?.()) return;

	try {
		const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
		await Haptics.impact({ style: ImpactStyle[style] || ImpactStyle.Light });
	} catch (error) {
		console.warn("Haptics unavailable.", error);
	}
};
